import React, { useState, useEffect } from 'react';
import Footer from '@/components/Footer';
import Banner from '@/components/Banner';
import Content from '@/components/Content';
import Navigation from '@/components/Navigation';

// 导入图片资源
import banner1Img from '../../public/images/banner-1.jpeg';
import banner2Img from '../../public/images/banner-2.png';

function App() {
	const [activeContentIndex, setContentIndex] = useState(0);
	useEffect(() => {}, [activeContentIndex]);
	return (
		<div className="app">
			<Navigation setActiveIndex={setContentIndex} />
			<Banner imgs={[banner1Img, banner2Img]} autoPlay={true} preview={false} />
			<Content activeIndex={activeContentIndex} />
			<Footer />
		</div>
	);
}

export default App;
